import store from "@/store";
import { axiosSingleton } from "../plugins/axios";

export function GetPerfilesByIdServicio(idServicio) {
  return axiosSingleton
    .getInstance()
    .get(
      process.env.NODE_ENV === "production"
        ? `https://enjambrec.ugto.mx/intraug/api/perfiles/GetPerfilesByIdServicio/${idServicio}`
        : `https://colmenac.ugto.mx/DSI/IntraUG/api/perfiles/GetPerfilesByIdServicio/${idServicio}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.oidc.id_token}`,
        },
      }
    );
}

export function getCampus() {
  return axiosSingleton
    .getInstance()
    .get(`https://enjambrec.ugto.mx/CatalogosUG/api/Generales/GetCampus`);
}

export function getDivisionesByIdCampus(idCampus) {
  return axiosSingleton
    .getInstance()
    .get(
      `https://enjambrec.ugto.mx/CatalogosUG/api/RecursosHumanos/GetDivisionesByIdCampus?idCampus=${idCampus}`
    );
}

export function getDepartamentoByIdDivision(idDivision) {
  return axiosSingleton
    .getInstance()
    .get(
      `https://enjambrec.ugto.mx/CatalogosUG/api/RecursosHumanos/GetDepartamentoByIdDivision?idDivision=${idDivision}`
    );
}

export function getConvocatoriaActiva() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/Convocatoria/GetConvocatoriaActiva",
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getInformacionBandeja() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/Bandeja",
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getInformacionBandejaConvocatorias() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: "/Convocatoria",
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getProtocolosProyectosBandeja() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Proyecto/GetProyectosBandeja`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getProtocolosProyectosBandejaRevision() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Proyecto/GetProyectosBandejaRevision`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getProtocolosProyectosBandejaEvaluacion() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Proyecto/GetProyectosBandejaEvaluacion`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getProtocolosProyectosBandejaEnvioCorreos() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Proyecto/GetProyectosBandejaEnvioCorreos`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getDatosGenerales(nue) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/DatosGenerales/DatosGenerales/${nue}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getProtocoloProyectoAccesoInfo(idProyecto, idAccion) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Proyecto/GetProyectoAccesoInfo/${idProyecto}/${idAccion}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getProtocoloProyectoAccesoInfoRevision(idProyecto) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Proyecto/GetProyectoAccesoInfoRevision/${idProyecto}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getProtocoloProyectoAccesoInfoEvaluacion(idProyecto) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Proyecto/GetProyectoAccesoInfoEvaluacion/${idProyecto}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getConvocatorias() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Catalogos/Convocatoria`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getTipoEnvioCorreo() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Catalogos/TipoEnvioCorreo`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getTiposProyectos() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Catalogos/TipoProyecto`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getTiposInvestigacion() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Catalogos/TipoInvestigacion`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getInsFinanciadora() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/InsFinanciadora/InsFinanciadora`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getAreas() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Catalogos/Area`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getTiposFinanciamiento() {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/TipoFinanciamiento/TipoFinanciamiento`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getDisciplinasByIdArea(idArea) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Catalogos/DisciplinaByIdArea/${idArea}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getBuscadorEmpleados(busqueda) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Buscador/Empleados?busqueda=${busqueda}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getBuscadorAlumnos(busqueda) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Buscador/Alumnos?busqueda=${busqueda}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getBuscadorEstatusAlumno(nua) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Buscador/EstatusAlumno?nua=${nua}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function postProtocoloProyecto(obj) {
  var formData = new FormData();

  formData.append("objProtocoloProyecto", JSON.stringify(obj));

  if (
    obj.datosProyecto.fileSolicitud != undefined &&
    obj.datosProyecto.fileSolicitud != null
  ) {
    formData.append("fileSolicitud", obj.datosProyecto.fileSolicitud);
  }

  if (
    obj.generalesProyecto.fileProtocolo != undefined &&
    obj.generalesProyecto.fileProtocolo != null
  ) {
    formData.append("fileProtocolo", obj.generalesProyecto.fileProtocolo);
  }

  try {
    if (
      obj.participantes.investigadorPrincipal.cv != undefined &&
      obj.participantes.investigadorPrincipal.cv != null
    ) {
      formData.append(
        "fileCVinvestigadorPrincipal",
        obj.participantes.investigadorPrincipal.cv
      );
    }
  } catch {}

  try {
    if (
      obj.participantes.investigadorResponsable.cv != undefined &&
      obj.participantes.investigadorResponsable.cv != null
    ) {
      formData.append(
        "fileCVinvestigadorResponsable",
        obj.participantes.investigadorResponsable.cv
      );
    }
  } catch {}

  try {
    if (obj.participantes.participantes.length > 0) {
      obj.participantes.participantes.forEach((item, index) => {
        if (item.cv != null && item.cv != undefined) {
          formData.append("fileCVPart_" + item.id + "_" + index, item.cv);
        }
      });
    }
  } catch {}

  try {
    if (
      obj.anexos.cartaConsentimiento.file != undefined &&
      obj.anexos.cartaConsentimiento.file != null
    ) {
      formData.append(
        "fileAnexoCartaConsentimiento",
        obj.anexos.cartaConsentimiento.file
      );
    }
  } catch {}

  try {
    if (
      obj.anexos.cartaInformacionParticipante.file != undefined &&
      obj.anexos.cartaInformacionParticipante.file != null
    ) {
      formData.append(
        "fileAnexoCartaInfoPart",
        obj.anexos.cartaInformacionParticipante.file
      );
    }
  } catch {}

  try {
    if (
      obj.anexos.informeTecnico.file != undefined &&
      obj.anexos.informeTecnico.file != null
    ) {
      formData.append(
        "fileAnexoInformeTecnico",
        obj.anexos.informeTecnico.file
      );
    }
  } catch {}

  try {
    if (
      obj.anexos.asentamientoInformadoMenores.file != undefined &&
      obj.anexos.asentamientoInformadoMenores.file != null
    ) {
      formData.append(
        "fileAnexoAsentInfMenores",
        obj.anexos.asentamientoInformadoMenores.file
      );
    }
  } catch {}

  try {
    if (
      obj.anexos.cuestionariosEncuestas.file != undefined &&
      obj.anexos.cuestionariosEncuestas.file != null
    ) {
      formData.append(
        "fileAnexoCuestEnc",
        obj.anexos.cuestionariosEncuestas.file
      );
    }
  } catch {}

  try {
    if (obj.anexos.documentosComplementarios.length > 0) {
      obj.anexos.documentosComplementarios.forEach((item, index) => {
        if (item.file != null && item.file != undefined) {
          formData.append(
            "fileArchivoAnexo_" + item.id + "_" + index,
            item.file
          );
        }
      });
    }
  } catch {}

  return axiosSingleton.getInstance()({
    method: "post",
    url: `/Proyecto`,
    data: formData,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
      "Content-Type": "multipart/form-data",
    },
  });
}

export function putProtocoloProyecto(obj) {
  var formData = new FormData();

  formData.append("objProtocoloProyecto", JSON.stringify(obj));

  if (
    obj.datosProyecto.fileSolicitud != undefined &&
    obj.datosProyecto.fileSolicitud != null
  ) {
    formData.append("fileSolicitud", obj.datosProyecto.fileSolicitud);
  }

  if (
    obj.generalesProyecto.fileProtocolo != undefined &&
    obj.generalesProyecto.fileProtocolo != null
  ) {
    formData.append("fileProtocolo", obj.generalesProyecto.fileProtocolo);
  }

  try {
    if (
      obj.participantes.investigadorPrincipal.cv != undefined &&
      obj.participantes.investigadorPrincipal.cv != null
    ) {
      formData.append(
        "fileCVinvestigadorPrincipal",
        obj.participantes.investigadorPrincipal.cv
      );
    }
  } catch {}

  try {
    if (
      obj.participantes.investigadorResponsable.cv != undefined &&
      obj.participantes.investigadorResponsable.cv != null
    ) {
      formData.append(
        "fileCVinvestigadorResponsable",
        obj.participantes.investigadorResponsable.cv
      );
    }
  } catch {}

  try {
    if (obj.participantes.participantes.length > 0) {
      obj.participantes.participantes.forEach((item, index) => {
        if (item.cv != null && item.cv != undefined) {
          formData.append("fileCVPart_" + item.id + "_" + index, item.cv);
        }
      });
    }
  } catch {}

  try {
    if (
      obj.anexos.cartaConsentimiento.file != undefined &&
      obj.anexos.cartaConsentimiento.file != null
    ) {
      formData.append(
        "fileAnexoCartaConsentimiento",
        obj.anexos.cartaConsentimiento.file
      );
    }
  } catch {}

  try {
    if (
      obj.anexos.cartaInformacionParticipante.file != undefined &&
      obj.anexos.cartaInformacionParticipante.file != null
    ) {
      formData.append(
        "fileAnexoCartaInfoPart",
        obj.anexos.cartaInformacionParticipante.file
      );
    }
  } catch {}

  try {
    if (
      obj.anexos.informeTecnico.file != undefined &&
      obj.anexos.informeTecnico.file != null
    ) {
      formData.append(
        "fileAnexoInformeTecnico",
        obj.anexos.informeTecnico.file
      );
    }
  } catch {}

  try {
    if (
      obj.anexos.asentamientoInformadoMenores.file != undefined &&
      obj.anexos.asentamientoInformadoMenores.file != null
    ) {
      formData.append(
        "fileAnexoAsentInfMenores",
        obj.anexos.asentamientoInformadoMenores.file
      );
    }
  } catch {}

  try {
    if (
      obj.anexos.cuestionariosEncuestas.file != undefined &&
      obj.anexos.cuestionariosEncuestas.file != null
    ) {
      formData.append(
        "fileAnexoCuestEnc",
        obj.anexos.cuestionariosEncuestas.file
      );
    }
  } catch {}

  try {
    if (obj.anexos.documentosComplementarios.length > 0) {
      obj.anexos.documentosComplementarios.forEach((item, index) => {
        if (item.file != null && item.file != undefined) {
          formData.append(
            "fileArchivoAnexo_" + item.id + "_" + index,
            item.file
          );
        }
      });
    }
  } catch {}

  return axiosSingleton.getInstance()({
    method: "put",
    url: `/Proyecto`,
    data: formData,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
      "Content-Type": "multipart/form-data",
    },
  });
}

export function postConvocatorias(obj) {
  return axiosSingleton.getInstance()({
    method: "post",
    url: `/Convocatoria/CrearConvocatoria`,
    data: obj,
  });
}

export function putConvocatorias(obj) {
  return axiosSingleton.getInstance()({
    method: "put",
    url: `/Convocatoria/EditarConvocatoria`,
    data: obj,
  });
}

export function deleteConvocatorias(obj) {
  return axiosSingleton.getInstance()({
    method: "delete",
    url: `/Convocatoria/EliminarConvocatoria`,
    data: obj,
  });
}

export function putProtocoloProyectoRevisado(idProyecto) {
  var obj = { idProyectoPk: idProyecto };

  return axiosSingleton.getInstance()({
    method: "put",
    url: `/Proyecto/PutProyectoSetRevisado`,
    data: obj,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function putProtocoloProyectoRevisadoObservaciones(idProyecto, obs) {
  var obj = { idProyectoPk: idProyecto, observacionesRevision: obs };

  return axiosSingleton.getInstance()({
    method: "put",
    url: `/Proyecto/PutProyectoSetRevisadoObservaciones`,
    data: obj,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function putProtocoloProyectoAprobado(idProyecto) {
  var obj = { idProyectoPk: idProyecto };

  return axiosSingleton.getInstance()({
    method: "put",
    url: `/Proyecto/PutProyectoSetAprobado`,
    data: obj,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function putProtocoloProyectoNoAprobado(idProyecto, obs) {
  var obj = { idProyectoPk: idProyecto, observacionesComite: obs };

  return axiosSingleton.getInstance()({
    method: "put",
    url: `/Proyecto/PutProyectoSetNoAprobado`,
    data: obj,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getArchivo(idTipoArchivo, idArchivo, uuid) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Archivo/ObtenerArchivo/${idTipoArchivo}/${idArchivo}/${uuid}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getArchivosTipoByIdProyecto(idProyecto) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Archivo/GetArchivosTipoByIdProyecto/${idProyecto}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getBitacoraObservaciones(idProyecto) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/BitacoraObservaciones/GetBitacoraObservacionesByIdProyecto/${idProyecto}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getBitacoraObservacionesInvestigador(idProyecto) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/BitacoraObservaciones/GetBitacoraObservacionesInvestigadorByIdProyecto/${idProyecto}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function postBitacoraObservaciones(obj) {
  return axiosSingleton.getInstance()({
    method: "post",
    url: `/BitacoraObservaciones/CrearBitacoraObservaciones`,
    data: obj,
  });
}

export function postBitacoraObservacionesPrincipal(obj, idEstatus) {
  return axiosSingleton.getInstance()({
    method: "post",
    url: `/BitacoraObservaciones/CrearBitacoraObservacionesPrincipal`,
    data: { cepiugBitacoraObservaciones: obj, idEstatus: idEstatus },
  });
}

export function putBitacoraObservacion(obj) {
  return axiosSingleton.getInstance()({
    method: "put",
    url: `/BitacoraObservaciones/PutBitacoraObservacion`,
    data: obj,
  });
}

export function putBitacoraObservacionesPrincipal(obj) {
  return axiosSingleton.getInstance()({
    method: "put",
    url: `/BitacoraObservaciones/PutBitacoraObservacionesPrincipal`,
    data: obj,
  });
}

export function putBitacoraObservacionVerificado(
  idBitacoraObservacion,
  idProyecto
) {
  var obj = {
    idBitacoraObservacionesPk: idBitacoraObservacion,
    idProyectoFk: idProyecto,
  };

  return axiosSingleton.getInstance()({
    method: "put",
    url: `/BitacoraObservaciones/PutBitacoraObservacionesVerificado`,
    data: obj,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function putBitacoraObservacionContestacion(
  idBitacoraObservacion,
  idProyecto,
  contestacion
) {
  var obj = {
    idBitacoraObservacionesPk: idBitacoraObservacion,
    idProyectoFk: idProyecto,
    contestacion: contestacion,
  };

  return axiosSingleton.getInstance()({
    method: "put",
    url: `/BitacoraObservaciones/PutBitacoraObservacionesContestacion`,
    data: obj,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getBitacoraObservacionesHistorial(idBitacoraObservacion) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/BitacoraObservacionesHistorial/GetBitacoraObservacionesHistorialByIdBitacoraObservaciones/${idBitacoraObservacion}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function deleteBitacoraObservacion(obj) {
  return axiosSingleton.getInstance()({
    method: "delete",
    url: `/BitacoraObservaciones/DeleteBitacoraObservacion`,
    data: obj,
  });
}

export function getDictamen(id, uuid) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Reporte/Dictamen/${id}/${uuid}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getReporteObservacionesProyecto(idProyecto, idPeriodo) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Reporte/reporteObservaciones/${idProyecto}/${idPeriodo}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getReporteProyectosByIdPeriodo(idPeriodo) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Reporte/reporteProyectosByIdPeriodo/${idPeriodo}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function postEnviarCorreoByIdProyectoIdConvocatoriaIdTipoEnvio(
  idProyecto,
  idConvocatoria,
  idTipoEnvio
) {
  return axiosSingleton.getInstance()({
    method: "post",
    url: `/Correos/PostEnviarCorreoByIdProyectoIdConvocatoriaIdTipoEnvio/${idProyecto}/${idConvocatoria}/${idTipoEnvio}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getBitacoraEnvioCorreosByIdProyectoIdConvocatoria(
  idProyecto,
  idConvocatoria
) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/BitacoraEnvioCorreos/GetBitacoraEnvioCorreosByIdProyectoIdConvocatoria/${idProyecto}/${idConvocatoria}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}

export function getProyectoBandejaEnvioCorreosByIdProyectoIdConvocatoria(
  idProyecto,
  idConvocatoria
) {
  return axiosSingleton.getInstance()({
    method: "get",
    url: `/Proyecto/GetProyectoBandejaEnvioCorreosByIdProyectoIdConvocatoria/${idProyecto}/${idConvocatoria}`,
    headers: {
      Authorization: `Bearer ${store.state.oidc.id_token}`,
    },
  });
}
